<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>
      <v-card-title class="">
        <span class="headline">Geribildirim Yazınız</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="content"
                  :rules="[$rules.empty('Geribildirim')]"
                  label="Geribildiriminiz"
                  rows="16"
                  required
                  shaped
              >
                </v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="blue darken-1" text @click="dialog = false">Kapat</v-btn>
        <v-btn color="blue darken-1" text @click="sendFeedBack">Gönder</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    content: '',
    dialog: false,
  }),
  methods: {
    ...mapActions({ send: 'sendBackend' }),
    sendFeedBack() {
      if (this.$refs.form.validate()) {
        const route = 'add/feedBack';
        this.send({ route, data: { content: this.content } })
          .then(() => { this.dialog = false; });
      }
    },
  },
  events: {
    'set:open': function () {
      this.dialog = !this.dialog;
    },
  },
};
</script>
